var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup9204(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9204"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#25C665"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0303 9.96967C22.3232 10.2626 22.3232 10.7374 22.0303 11.0303L13.7803 19.2803C13.4874 19.5732 13.0126 19.5732 12.7197 19.2803L8.96967 15.5303C8.67678 15.2374 8.67678 14.7626 8.96967 14.4697C9.26256 14.1768 9.73744 14.1768 10.0303 14.4697L13.25 17.6893L20.9697 9.96967C21.2626 9.67678 21.7374 9.67678 22.0303 9.96967Z",
    fill: "#565966"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9204);
export default __webpack_public_path__ + "static/media/Group 9204.5fa9b058171700bb6e5e1f47e4bb43a1.svg";
export { ForwardRef as ReactComponent };